import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { api } from "../../convex/_generated/api"
import type { Id } from "../../convex/_generated/dataModel"
import { MessagesInbox, type InboxThread } from "@/components/messages-inbox"

export const Route = createFileRoute("/recruit/messages")({
  validateSearch: (search: Record<string, unknown>) => ({
    thread:
      typeof search.thread === "string"
        ? (search.thread as Id<"outreachThreads">)
        : undefined,
  }),
  component: RecruitMessagesPage,
})

function RecruitMessagesPage() {
  const { thread } = Route.useSearch()
  const navigate = useNavigate()
  const threads = useQuery(api.outreach.listForCompany)

  const inboxThreads: InboxThread[] | undefined = threads?.map((t) => ({
    _id: t._id,
    peerName: t.seekerName,
    peerSubtitle: t.seekerHeadline,
    peerAvatarUrl: t.seekerAvatarUrl,
    jobTitle: t.jobTitle,
    jobId: t.jobId,
    lastMessagePreview: t.lastMessagePreview,
    lastMessageAt: t.lastMessageAt,
    unread: t.unread,
    seekerId: t.seekerId,
  }))

  return (
    <MessagesInbox
      mode="company"
      threads={inboxThreads}
      emptyCopy="When you message an applicant from a job, the conversation stays here."
      emptyCta={{ label: "Your jobs", to: "/recruit/jobs" }}
      selectedThreadId={thread ?? null}
      onThreadChange={(threadId) => {
        void navigate({
          to: "/recruit/messages",
          search: { thread: threadId ?? undefined },
          replace: true,
        })
      }}
    />
  )
}
